// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__zVEdJ","inner":"Notification_inner__WJWWI","show":"Notification_show__USr0x","caution":"Notification_caution__z0Gx7"};